<template>
  <confirm-dialog
    ref="dialog"
    :title="'Tracking Record ' + mode"
    :confirmCb="confirmChange"
    :cancelCb="cancelCb"
    :width="55"
    :loading="loading"
  >
    <template v-slot:content>
      <div class="f-r" style="gap: 20px">
        <div class="f-c" style="gap: 5px">
          <div class="basic-infos">
            <div style="width: 100px">Quantity:</div>
            <el-input-number size="medium" :step="1" v-model="quantity" />
          </div>
          <div class="basic-infos">
            <div style="width: 100px">Weight:</div>
            <el-input-number size="medium" :step="0.01" v-model="weight" />
          </div>
        </div>
        <div class="f-c right-description">
          <span>Description</span>
          <el-input
            :autosize="{
              minRows: 4
            }"
            size="medium"
            type="textarea"
            v-model="description"
          />
        </div>
      </div>
      <div class="tracking-record-new-wrapper f-r" v-loading="loading">
        <div class="pallet-list pallet-list-wrapper">
          <div class="header">
            <el-input
              size="small"
              placeholder="Input to search"
              prefix-icon="el-icon-search"
              v-model="searchPalletInput"
              :clearable="true"
            />
            <span class="header-text">
              Scroll vertically to view all or input to search
            </span>
          </div>
          <div class="content f-c">
            <div
              class="pallet-item light-oswald"
              v-for="pallet in filteredPallets"
              :key="pallet.id"
            >
              <div class="left">
                <div class="first-row">{{ pallet.no }}</div>
                <div class="first-row">
                  <div>{{ pallet.riiOrderNo }}</div>
                  <div>{{ pallet.address.name }}</div>
                </div>
              </div>
              <div class="right">
                <el-button
                  size="small"
                  circle
                  class="button"
                  @click="() => addPallet(pallet)"
                >
                  <svg-icon icon-class="plus2" style="font-size: 15px" />
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="selected-pallets-wrapper pallet-list">
          <div class="header">
            <div class="light-oswald title">Selected Pallets</div>
            <span>{{ selectedPallets.length }} Pallets</span>
          </div>
          <div class="content f-c">
            <div
              class="pallet-item light-oswald"
              v-for="pallet in selectedPallets"
              :key="pallet.id"
            >
              <div class="left">
                <div class="first-row">{{ pallet.no }}</div>
                <div class="first-row">{{ pallet.riiOrderNo }}</div>
                <div class="first-row">{{ pallet.address.name }}</div>
              </div>
              <div class="right">
                <el-button
                  size="small"
                  circle
                  class="button"
                  @click="() => removePallet(pallet)"
                >
                  <svg-icon icon-class="trash" style="font-size: 15px" />
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </confirm-dialog>
</template>
<script>
import ConfirmDialog from '@/components/common/Confirm.vue'
import { queryAddress } from '@/api/address'
import {
  createTrackingRecord,
  queryShipmentPallets,
  updateTrackingRecord
} from '@/api/tracking'
export default {
  name: 'TrackingRecordNew',
  components: {
    ConfirmDialog
  },
  props: {
    successCb: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      mode: '',
      loading: false,
      searchPalletInput: '',
      pallets: [],
      shipmentId: '',
      recordId: '',
      selectedPallets: [],
      selectedPalletIds: [],
      quantity: 1,
      weight: 1,
      description: ''
    }
  },
  computed: {
    filteredPallets() {
      const regex = new RegExp(this.searchPalletInput, 'i')
      const filtered = this.pallets.filter(one => {
        const flag1 = regex.test(one.no) // one.no.includes(this.searchPalletInput)
        const flag2 = regex.test(one.groupName) // one.groupName.includes(this.searchPalletInput)
        const flag3 = !one.recordNo
        const flag4 = regex.test(one.riiOrderNo) // .includes(this.searchPalletInput)
        const flag5 = one?.address?.code && regex.test(one.address.code)
        return flag3 && (flag1 || flag2 || flag4 || flag5)
      })
      return filtered
    }
  },
  watch: {},
  methods: {
    open(
      mode,
      shipmentId,
      selectedPalletIds,
      recordId = undefined,
      quantity = 0,
      weight = 0,
      desc = ''
    ) {
      this.$set(this, 'mode', mode)
      this.$set(this, 'shipmentId', shipmentId)
      this.$set(this, 'selectedPalletIds', selectedPalletIds)
      this.quantity = quantity
      this.weight = weight
      this.description = desc
      this.fetchShipmentPallets()
      this.recordId = recordId
      this.$refs.dialog.open()
    },
    confirmChange(close, error) {
      if (this.quantity <= 0) {
        error('quantity is zero')
        return
      }
      if (this.weight <= 0) {
        error('desc is zero')
        return
      }
      if (this.selectedPallets.length === 0) {
        error('No pallet selected')
        return
      }
      const func = this.recordId ? updateTrackingRecord : createTrackingRecord
      const data = {
        shipmentId: this.shipmentId,
        palletIds: this.selectedPallets.map(one => one.id),
        recordId: this.recordId,
        weight: this.weight,
        quantity: this.quantity,
        description: this.description
      }
      this.loading = true
      func(data)
        .then(() => {
          close()
          this.successCb()
        })
        .catch(err => {
          error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelCb() {
      this.reset()
    },
    reset() {
      this.$set(this, 'mode', 'New')
      this.$set(this, 'shipmentId', '')
      this.$set(this, 'selectedPalletIds', [])
      this.recordId = undefined
    },
    addPallet(pallet) {
      const index = this.pallets.findIndex(one => one.id === pallet.id)
      if (index > -1) {
        this.pallets.splice(index, 1)
        this.selectedPallets.push(pallet)

        this.selectedPallets.sort()
        this.pallets.sort()
      }
    },
    removePallet(pallet) {
      const index = this.selectedPallets.findIndex(one => one.id === pallet.id)
      if (index > -1) {
        this.selectedPallets.splice(index, 1)
        this.pallets.push(pallet)

        this.selectedPallets.sort()
        this.pallets.sort()
      }
    },
    async fetchShipmentPallets() {
      const records = await queryShipmentPallets(this.shipmentId)
      const addressIds = new Set(records.map(one => one.addressId))
      if (addressIds.size > 0) {
        const addressPage = await queryAddress({
          addressIds: Array.from(addressIds),
          size: -1
        })
        const addressMap = Object.fromEntries(
          addressPage.records.map(one => [one.id, one])
        )
        records.forEach(one => (one.address = addressMap[one.addressId]))
      }
      records.sort((one, two) => one.no.localeCompare(two.no))
      // restore selected pallets
      const selected = records.filter(one =>
        this.selectedPalletIds.includes(one.id)
      )
      const options = records.filter(
        one => !this.selectedPalletIds.includes(one.id)
      )

      this.$set(this, 'pallets', options)
      this.$set(this, 'selectedPallets', selected)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';
.tracking-record-new-wrapper {
  width: 100%;
  gap: 10px;
  display: flex;
  flex-direction: row;
  .selected-pallets-wrapper {
    flex-grow: 1;
    flex-shrink: 1;
    width: 50%;
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 20px;
      margin-bottom: 22px;
      .title {
        font-size: 20px;
      }
    }
  }
}

.pallet-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 400px;
  padding-right: 4px;
  flex-grow: 1;
  width: 50%;
  flex-shrink: 1;
  .header-text {
    font-size: 12px;
    color: #666;
    font-style: italic;
  }
  .content {
    overflow-x: hidden;
    overflow-y: auto;
    gap: 10px;
    &::-webkit-scrollbar {
      width: 10px;
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #ada9a9;
    }
  }
  .pallet-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    &.empty {
      background-color: #ddd;
      cursor: not-allowed;
    }
    @extend .common-card-padding;

    flex-wrap: wrap;
    .left {
      display: flex;
      flex-direction: column;
    }
    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 5px;

      .button {
        width: 26px;
        height: 26px;
        padding: 2px;
        margin: 0px;
      }
    }
  }
}
.right-description {
  flex-grow: 1;
}
</style>
